module.exports = __webpack_public_path__ + "media/images/nike-38aacbe4dc67be52626e744676dfce68.svg";